async function changeCamera() {
    await expivi.setProductAttributeNamed('Camera reset', 'Yes');
}

function createConfiguration(savedBundle) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            type: 'POST',
            url: '/apps/configurator',
            data: JSON.stringify({
                configuration: savedBundle.configured_products,
                productId: shopifyProductId
            }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(function(createResult) {
            createResult.configuredProduct = savedBundle.configured_products[0];
            resolve(createResult);
        }).fail(reject);
    });
}

async function getVariant(data) {
    const configuredProduct = data.configuredProduct;
    const article = configuredProduct.articles.find((item) => !isNaN(parseInt(item.material_group_sku)));
    if (!article) {
        throw new Error('variant id not found');
    }

    const quantityAttr = configuredProduct.attributes.find((item) => item.attribute_key === 'att-quantity');
    const quantity = parseInt(quantityAttr.attribute_value_name);

    if (isNaN(quantity)) {
        throw new Error('quantity not defined');
    }

    return {
        configuredProduct: configuredProduct,
        variant_id: parseInt(article.material_group_sku),
        options: {
            _thumbnail: data.thumbnail,
            _configuration_link: data.options['Configuration Link'],
        },
        quantity: quantity,
    };
}

function getPrintReadyFile(data) {
    return new Promise(function (resolve) {
        const configuredProduct = data.configuredProduct;
        const designAttribute = configuredProduct.attributes.find(function (attr) {
            return attr.attribute_value &&
                Number.isInteger(attr.attribute_value.media_id) &&
                attr.attribute_value.svg_element;
        });

        if (!designAttribute) {
            return resolve(data);
        }

        requestPrintReadyFile(data, designAttribute.attribute_value.media_id)
            .then(function (filePath) {
                data.options['_print_ready_file'] = filePath;

                resolve(data);
            });
    });
}

function requestPrintReadyFile(data, mediaId) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: '/apps/configurator',
            type: 'POST',
            data: JSON.stringify({
                svg_convert: true,
                configuration: {
                    catalogue_id: data.configuredProduct.catalogue_id,
                    attributes: data.configuredProduct.configuration.attributes
                },
                media_id: mediaId,
                format: 'pdf',
                dpi: data.dpi,
                hide_printmarks: true,
                hide_placeholders: true,
                cmyk: false,
            }),
            contentType: "application/json"
        }).done(function (response) {
            if (!response.status) {
                return reject();
            }

            resolve('https://decofill.expivi.net/print-ready-service?hash='+response.hash);
        });
    });
}

function addToCart(createResult) {
    return new Promise(function (resolve, reject) {
        let addJsResponse = {
            quantity: createResult.quantity,
            id: createResult.variant_id,
            properties: createResult.options,
        };

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify(addJsResponse),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(resolve).fail(reject);
    });
}

window.xpv_hooks_add_to_cart = function(context, event) {
    $button = $(context);
    shopifyProductId = $button.data('productId');

    // Disable button
    if ($button[0].hasAttribute('disabled')) {
        return false;
    }
    event.preventDefault();
    $button.attr('disabled', 'disabled');
    $button.addClass('loading');

    return Promise.resolve()
        .then(function() {
            return changeCamera();
        })
        .then(function() {
            return expivi.saveConfiguration(512, 512, 'ACTIVE_CAMERA', 'image/jpeg', { include_keys: true })
        })
        .then(function(result) {
            return createConfiguration(result);
        })
        .then(function(result) {
            return getVariant(result);
        })
        .then(function(results) {
            return getPrintReadyFile(results);
        })
        .then(function(result) {
            return addToCart(result)
        })
        .then(function() {
            if ($button.data('url') !== 'NONE') {
                window.location.href = $button.data('url');
            }

            // Don't let expivi handle add to cart
            return false;
        })
        .catch(function (error) {
            $button.removeAttr('disabled');
            $button.removeClass('loading');
            if (error && error.invalid) {
                console.error(error.message);
                return;
            }
            throw error;
        });
}
